import { Dispatch, SetStateAction } from 'react';
import { SortType } from 'shared/components';
import { TableSort } from '../constants';

export const defaultSort: TableSort = {
  id: 'id',
  direction: SortType.ASC
};

export const defaultSortingBehavior = (
  payload: any,
  setSort: Dispatch<SetStateAction<TableSort | null>>,
  sort: TableSort | null = null
) => {
  if (payload) {
    // Reset sorting after sort twice with the same field
    if (sort?.id === payload.id && sort?.direction === SortType.ASC && payload.direction === SortType.ASC) {
      return setSort(defaultSort);
    }

    switch (payload.direction) {
      case null:
      case SortType.ASC:
        return setSort({
          direction: SortType.DESC,
          id: payload.id
        });
      case SortType.DESC:
        return setSort({
          ...defaultSort,
          id: payload.id
        });
    }
  }
};
